import React from 'react'
import classnames from 'classnames';
import styles from '../styles/ToolTip.module.scss';

type Props = {
  text: string;
  children: Object;
  direction: string;
};

const ToolTip: React.FC<Props>  = ({text, children, direction}) => {

  // This sets the direction of tooltip based 
  const textStyle = classnames({
    [styles.tooltiptext]: true,
    [styles.tooltiptextTop]: direction === "top" ? true:false,
    [styles.tooltiptextBottom]: direction === "bottom" ? true:false,
    [styles.tooltiptextRight]: direction === "right" ? true:false,
    [styles.tooltiptextLeft]: direction === "left" ? true:false,

  });

  return (
    <div className={styles.tooltip}>
        <>
        {children}
        </>
        <span className={textStyle}>
          <div>
          {text}
          </div>
        </span>
    </div>
  )
}

export default ToolTip
